"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const TrialsLifeCycleItem_vue_1 = __importDefault(require("./TrialsLifeCycleItem.vue"));
const RowDetailTrial_vue_1 = __importDefault(require("./RowDetailTrial.vue"));
const trans_1 = require("@common/tsutils/trans");
const ProjectInfoController_1 = __importDefault(require("./utils/controllers/ProjectInfoController"));
let TableTrialsTracking = class TableTrialsTracking extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.tableHeaderOptions = [
            (0, trans_1.trans)('trialsInTracking.table.head_global.t_head_1'),
            (0, trans_1.trans)('trialsInTracking.table.head_global.t_head_2'),
            (0, trans_1.trans)('trialsInTracking.table.head_global.t_head_3'),
            (0, trans_1.trans)('trialsInTracking.table.head_global.t_head_4'),
            (0, trans_1.trans)('trialsInTracking.table.head_global.t_head_5'),
        ];
        this.controller = new ProjectInfoController_1.default();
        this.statusActive = '';
    }
    get internal_theme() {
        if (this.theme)
            return this.theme;
        return this.$theme.current.value;
    }
    created() {
        this.controller.callProjectInfo(this.proposalId);
        this.controller.callSamplesGlobal(this.projectId);
        this.reload();
    }
    reload() {
        var _a, _b;
        let hasGheom = true;
        if (((_b = (_a = this.projectInfo) === null || _a === void 0 ? void 0 : _a.proposal) === null || _b === void 0 ? void 0 : _b.crop) === '-') {
            hasGheom = false;
        }
        this.$emit('toastTrialsNotGheom', hasGheom);
    }
    get allSamples() {
        return this.controller.collectAllSamples;
    }
    samplesFilterGlobal() {
        let sampleT;
        for (const sample of this.allSamples) {
            if (sample.sample_code.toUpperCase() ===
                this.globalTextSearch.toUpperCase().trim()) {
                sampleT = sample;
            }
        }
        this.statusActive = sampleT === null || sampleT === void 0 ? void 0 : sampleT.status;
        if (this.globalTextSearch.length < 6) {
            this.statusActive = '';
        }
    }
    get projectInfo() {
        return this.controller.collectProjectInfo;
    }
    get loadingProjectInfo() {
        return this.controller.collectLoadingProjectInfo;
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Number, default: null })
], TableTrialsTracking.prototype, "proposalId", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Number, default: null })
], TableTrialsTracking.prototype, "projectId", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: false })
], TableTrialsTracking.prototype, "isBMK", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: '' })
], TableTrialsTracking.prototype, "globalTextSearch", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: null })
], TableTrialsTracking.prototype, "theme", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('projectInfo')
], TableTrialsTracking.prototype, "reload", null);
__decorate([
    (0, vue_property_decorator_1.Watch)('globalTextSearch')
], TableTrialsTracking.prototype, "samplesFilterGlobal", null);
TableTrialsTracking = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            TableBmk: bmk_ui_framework_1.TableBmk,
            TableHeader: bmk_ui_framework_1.TableHeader,
            TableBody: bmk_ui_framework_1.TableBody,
            TableHeaderCell: bmk_ui_framework_1.TableHeaderCell,
            TrialsLifeCycleItem: TrialsLifeCycleItem_vue_1.default,
            TableBodyRow: bmk_ui_framework_1.TableBodyRow,
            TableBodyCell: bmk_ui_framework_1.TableBodyCell,
            RowDetailTrial: RowDetailTrial_vue_1.default,
            CodeSnippet: bmk_ui_framework_1.CodeSnippet,
            Toasts: bmk_ui_framework_1.Toasts,
            WarningSquaredIcon: bmk_ui_framework_1.WarningSquaredIcon,
        },
    })
], TableTrialsTracking);
exports.default = TableTrialsTracking;
